<template>
  <el-select v-model="role" :placeholder="placeholder" :multiple="multiple">
    <el-option
      v-for="(item, key) in roles"
      :key="key"
      :label="item.label"
      :value="item.value"
    >
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: "RoleSelect",
  props: ["placeMsg", "allowMultiple"],
  data() {
    return {
      placeholder: this.placeMsg,
      multiple: this.allowMultiple,
      roles: [
        {
          value: 100,
          label: "系统管理员",
        },
        {
          value: 101,
          label: "组织部汇总账号",
        },
        {
          value: 102,
          label: "局级管理账号",
        },
        {
          value: 103,
          label: "局长级",
        },
        {
          value: 104,
          label: "局党组",
        },
        {
          value: 105,
          label: "考核领导小组",
        },
        {
          value: 106,
          label: "副局长级",
        },

        {
          value: 107,
          label: "科长级",
        },

        {
          value: 108,
          label: "科员级",
        },
        {
          value: 109,
          label: "外部打分",
        },
        {
          value: 110,
          label: "牵头科室",
        },
        {
          value: 111,
          label: "特殊小组1",
        },
      ],
      role: "",
    };
  },

  watch: {
    role(newVal, oldVal) {
      this.$emit("role", this.role);
    },
  },
};
</script>

<style scoped lang="scss">
</style>